import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/bienvenida/bienvenida';
import CreateEditBienvenida from './CreateEditBienvenida';


const ms2p = (state) => {
  return {
    ...state.bienvenida,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(CreateEditBienvenida);
